import { LoadingService } from '../../../shared/services/loading/loading.service';

export const companyTabLoadingService = new LoadingService();
